import { render, staticRenderFns } from "./WFOWFHChart.vue?vue&type=template&id=1361e9c7&scoped=true"
import script from "./WFOWFHChart.vue?vue&type=script&lang=js"
export * from "./WFOWFHChart.vue?vue&type=script&lang=js"
import style0 from "./WFOWFHChart.vue?vue&type=style&index=0&id=1361e9c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361e9c7",
  null
  
)

export default component.exports